import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-comparison-skeleton-loader',
    templateUrl: './comparison-skeleton-loader.component.html',
    styleUrls: ['./comparison-skeleton-loader.component.scss'],
    standalone: false
})
export class ComparisonSkeletonLoaderComponent implements OnInit {

  @Input() type;
  constructor() { }

  ngOnInit() {
  }

}
